import { CompanyAccess } from "@me-team/host/main/graphql/types";
import AccessService from "@me-team/host/services/AccessService";

export const getSidebarAccess = () => {
    const accessService = AccessService.getInstance();

    const canAccessServiceListRoot = accessService.hasPermission(CompanyAccess.ServiceListView);
    const canAccessServiceCategoriesRoot = accessService.hasPermission(CompanyAccess.ServiceCategoryListView);
    const canCreateService = accessService.hasPermission(CompanyAccess.ServiceCreate);

    const canAccessClientListRoot = accessService.hasPermission(CompanyAccess.ClientListView);
    const canCreateClient = accessService.hasPermission(CompanyAccess.ClientCreate);

    const canAccessEmployeeListRoot = accessService.hasPermission(CompanyAccess.EmployeeListView);
    const canCreateEmployee = accessService.hasPermission(CompanyAccess.EmployeeCreate);
    const canAccessPositionListRoot = accessService.hasPermission(CompanyAccess.PositionListView);
    const canAccessWorkScheduleRoot = accessService.hasPermission(CompanyAccess.ScheduleCalendarView);
    const canAccessSalaryRoot = accessService.hasPermission(CompanyAccess.SalaryView);
    const canAccessPaymentsHistoryRoot = accessService.hasPermission(CompanyAccess.PaymentsHistoryView);
    const canAccessTariffManagementRoot = accessService.hasPermission(CompanyAccess.TariffView);
    const canAccessTariffModulesManageRoot = accessService.hasPermission(CompanyAccess.TariffModulesManage);
    const canAccessAccessSettingsRoot = accessService.hasPermission(CompanyAccess.AccessSettingsView);

    const canAccessOnlineBookingSettingsRoot = accessService.hasAnyPermission([
        CompanyAccess.OnlineBookingSettingsView,
        CompanyAccess.OnlineBookingSettingsEdit,
    ]);
    const canAccessReviewsRoot = accessService.hasPermission(CompanyAccess.ReviewListView);

    const canAccessLogbookJournal = accessService.hasPermission(CompanyAccess.LogbookView);
    const canCreateLogbookRecord = accessService.hasPermission(CompanyAccess.LogbookBookingCreate);
    const canAccessBookingStatistic = accessService.hasPermission(CompanyAccess.BookingStatisticViewExport);

    const canAccessWarehouseListRoot = accessService.hasPermission(CompanyAccess.WarehouseListView);
    const canAccessWarehouseOperationsRoot = accessService.hasPermission(CompanyAccess.WarehouseOperationListView);
    const canAccessProductsRoot = accessService.hasPermission(CompanyAccess.ProductListView);
    const canCreateProductRoot = accessService.hasPermission(CompanyAccess.ProductCreate);
    const canAccessTechMapsRoot = accessService.hasPermission(CompanyAccess.TechMapListView);
    const canAccessWarehouseReportsRoot = accessService.hasPermission(CompanyAccess.WarehouseReportViewExport);
    const canAccessProductCategoriesRoot = accessService.hasPermission(CompanyAccess.ProductCategoryListView);
    const canAccessTechMapCategoriesRoot = accessService.hasPermission(CompanyAccess.TechMapCategoryListView);

    const canAccessMenuListRoot = accessService.hasPermission(CompanyAccess.MenuListView);
    const canCreateMenu = accessService.hasPermission(CompanyAccess.MenuCreate);
    const canAccessMenuDishListRoot = accessService.hasPermission(CompanyAccess.MenuDishListView);
    const canCreateMenuDish = accessService.hasPermission(CompanyAccess.MenuDishCreate);
    const canAccessMenuDishCategoryListRoot = accessService.hasPermission(CompanyAccess.MenuDishCategoryListView);
    const canAccessMenuOptionsAndSupplementsListRoot = accessService.hasPermission(
        CompanyAccess.MenuOptionsAndSupplementsListView
    );

    const hasOnlineBookingRootAccess = canAccessOnlineBookingSettingsRoot || canAccessReviewsRoot;
    const hasServicesRootAccess = canAccessServiceListRoot || canAccessServiceCategoriesRoot;
    const hasTariffManagementRootAccess = canAccessTariffManagementRoot;
    const hasWarehouseRootAccess =
        canAccessWarehouseListRoot ||
        canAccessWarehouseOperationsRoot ||
        canAccessProductsRoot ||
        canCreateProductRoot ||
        canAccessTechMapsRoot ||
        canAccessWarehouseReportsRoot ||
        canAccessBookingStatistic ||
        canAccessProductCategoriesRoot ||
        canAccessTechMapCategoriesRoot;
    const hasMenuRootAccess = canAccessMenuListRoot || canCreateMenu;
    const hasMenuDishesRootAccess =
        canAccessMenuDishListRoot || canAccessMenuDishCategoryListRoot || canAccessMenuOptionsAndSupplementsListRoot;

    return {
        hasModeratorRole: accessService.hasModeratorRole,

        canAccessServiceListRoot,
        canAccessServiceCategoriesRoot,
        canCreateService,
        hasServicesRootAccess,

        canAccessClientListRoot,
        canCreateClient,
        canAccessClientHistoryRoot: canAccessClientListRoot,

        canAccessEmployeeListRoot,
        canCreateEmployee,
        canAccessPositionListRoot,
        canAccessWorkScheduleRoot,
        canAccessSalaryRoot,
        canAccessPaymentsHistoryRoot,
        canAccessTariffManagementRoot,
        canAccessTariffModulesManageRoot,
        hasTariffManagementRootAccess,
        canAccessAccessSettingsRoot,

        canAccessOnlineBookingSettingsRoot,
        canAccessReviewsRoot,
        hasOnlineBookingRootAccess,

        canAccessLogbookJournal,
        canCreateLogbookRecord,
        canAccessBookingStatistic,
        canAccessLogbookRoot: canAccessLogbookJournal || canCreateLogbookRecord || canAccessBookingStatistic,

        canAccessWarehouseListRoot,
        canAccessWarehouseOperationsRoot,
        canAccessProductsRoot,
        canCreateProductRoot,
        canAccessTechMapsRoot,
        canAccessWarehouseReportsRoot,
        canAccessProductCategoriesRoot,
        canAccessTechMapCategoriesRoot,
        hasWarehouseRootAccess,

        canAccessMenuListRoot,
        canCreateMenu,
        canAccessMenuDishListRoot,
        canCreateMenuDish,
        canAccessMenuDishCategoryListRoot,
        canAccessMenuOptionsAndSupplementsListRoot,
        hasMenuRootAccess,
        hasMenuDishesRootAccess,
    };
};
